export const STORAGE_KEYS = {
  TOKEN: 'store_token',
  REFRESH_TOKEN: 'store_refresh_token',
  CUSTOMER_ID: 'store_customer_id',
  EMAIL: 'store_email',
  DISPLAY_NAME: 'store_display_name',
  COLOR_MODE: 'store_color_mode',
  BRANCH_ID: 'store_branch_id',
  PRICE_LIST_ID: 'store_price_list_id',
  CURRENCY: 'store_currency',
  LOCALE: 'store_locale',
  ADMIN_TOKEN: 'store_admin_token',
  ADMIN_DISPLAY_NAME: 'store_admin_display_name',
  COOKIES_ACCEPTED: 'store_cookies_accepted',
} as const;
